import { ChangeEventHandler } from 'react'
import HTMLInput from './HTMLInput'
import { CourseContent } from '@bm-js/atlascloud-shared'

type Props = {
  content: CourseContent
  setContentData: (data: CourseContent['data']) => void
}

const CourseEditableRichText = ({ content, setContentData }: Props) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setContentData({ ...content.data, html: e.target.value })
  }
  return (
    <div>
      <HTMLInput value={content.data.html} onChange={handleChange} />
    </div>
  )
}

export default CourseEditableRichText
